/*eslint-disable*/
import React from 'react'
import { Form as Formiker, Field, withFormik } from 'formik'
import { Link } from 'react-router-dom'
import * as Yup from 'yup';
import sha256 from 'sha256';
import Axios from 'axios';
import sha1 from 'sha1'
import APP_CONSTANT from '../../config/constants'
const pControl = {
  height: "40px",
  borderRadius: "10px",
  color: "black"
}


const LoginView = ({ values, errors, touched, isSubmitting }) => (
  <React.Fragment>
    <div className="container">
      <div className="row">
        <div className="col-md-4 col-sm-4 offset-md-4 w3-white w3-card mt-5 w3-round-xxlarge">
          <div className="row">
            <div className="col-md-2 col-sm-2 mt-5 offset-md-4">
              <img className="p-1 ml-4" alt="" src="assets/svg/fleet.svg" width="60" />
            </div>
          </div>
          <div className="row">
            <div className="col-md-10 col-sm-10 mt-0 offset-md-1">
              <p className="font-weight-bolder titleName text-center w3-text-blue">Logistics control tower</p>
            </div>
          </div>
          <Formiker>
            <div className="row">
              <div className="col-md-10 offset-md-1 col-sm-10 offset-sm-1">
                <div className="text-center mt-3 ml-5 mr-5">
                  <Field name="username" className="form-control w3-card w3-border w3-hover-border-blue" style={pControl} type="text" placeholder="username" />
                  {touched.username && errors.username && <small>{errors.username}</small>}
                  {/* <span className="erricon" style={erricon}>{this.state.errors ? <span> <i title="invalid Username" className="fas fa-times-circle animated rotateIn"></i> </span> : ""}
                                        {this.state.correct ? <i className="fas fa-check-circle w3-text-blue animated rotateIn"></i> : ''}
                                    </span> */}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-10 offset-md-1 col-sm-10 offset-sm-1">
                <div className="text-center mt-4 mb-2 ml-5 mr-5">
                  <Field name="password" className="form-control p-control w3-card w3-border w3-hover-border-blue" style={pControl} type="password" placeholder="password" />
                  {touched.password && errors.password && <small>{errors.password}</small>}
                  {/* <span className="erricon" style={erricon}>{this.state.errors ? <span> <i title="invalid password" className="fas fa-times-circle animated rotateIn" data-toggle="tooltip" data-placement="right"></i> </span> : ''}
                                        {this.state.correct ? <i className="fas fa-check-circle w3-text-blue animated rotateIn"></i> : ''}
                                    </span> */}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-10 offset-md-1 col-sm-10 offset-sm-1">
                <div className="text-center mt-4 mb-5 ml-5 mr-5">
                  <input className="form-check-input small" type="checkbox" value="" id="invalidCheck" />
                  <label className="form-check-label small" htmlFor="invalidCheck">
                    Remember Me
                  </label>
                  <p><button type="submit" disabled={isSubmitting} className="w3-button p-outline-none mt-4 p-btn w3-blue w3-hover-blue w3-round-xlarge w3-large"><small>Sign In</small></button></p>
                  <small> forgot <Link to="#"><b>password & username</b></Link> ?</small>
                </div>
              </div>
            </div>
          </Formiker>
        </div>
      </div>
    </div>
  </React.Fragment>
)

const FormikLogin = withFormik({
  mapPropsToValues({ username, password }) {
    return {
      username: username || '',
      password: password || ''
    }
  },
  validationSchema: Yup.object().shape({
    username: Yup.string().required('username Required'),
    password: Yup.string().required('password Required')
  }),
  handleSubmit(values, { setErrors, setSubmitting }) {
    let userName = values.username
    let password = sha1(values.password)
    let sha2Password = sha256(values.password)
    let data = JSON.stringify
      ({
        username: userName,
        password: values.password,
        // sha2_password: sha2Password
      })
    Axios.post(`${APP_CONSTANT.BASE_URL}sso/login`, data, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': "*",
      },
    })
      .then((response => {
        console.log(response)
        if (response.data.status === 200) {

          setSubmitting(false)
          let userKey = response.data.resultSet.token
          let userId = response.data.resultSet.userId
          let roleId = response.data.resultSet.roleId
          let role = response.data.resultSet.role
          let realName = response.data.resultSet.realName
          let customerNo = response.data.resultSet.customerNo
          let userKeyS = response.data.resultSet.userKey
          localStorage.setItem('apiToken', userKey)
          localStorage.setItem('realName', realName)
          localStorage.setItem('userId', userId)
          localStorage.setItem('roleId', roleId)
          localStorage.setItem('role', role)
          localStorage.setItem('customerNo', customerNo)
          localStorage.setItem('userKey', userKeyS)

          if (role === "User") {
            window.location.href = "/jobcard"
          } else if (role.toLowerCase() === "approver") {
            window.location.href = "/approvals"
          }
          else {
            window.location.href = "/home"
          }
          setSubmitting(false)

        } else {
          alert(response.data.message)
          setSubmitting(false)
        }

      }))
      .catch((error) => {
        setSubmitting(false)
        alert(error?.response?.data?.message ? error.response.data.message : "Error while Login, please check your credentials or try again!!!")
        console.log(error)
      })
  }
})(LoginView)

export default FormikLogin